import i18n from 'segments/i18n';

import { TransactionType } from '../store/types';

export const transactionTypeTitles: Record<TransactionType, string> = {
  'admin_refill': i18n.t('transactions.titles.admin-refill', 'Начисление администратором'),
  'admin_withdrawal': i18n.t('transactions.titles.admin-withdrawal', 'Списание администратором'),
  'booking_payment': i18n.t('transactions.titles.booking_payment', 'Списание резерва'),
  'booking_cancellation': i18n.t('transactions.titles.booking_cancellation', 'Отмена резерва'),
  'group_payment': i18n.t('transactions.titles.group_payment', 'Оплата группы')
};

export const transactionTypes: TransactionType[] = ['admin_refill', 'admin_withdrawal', 'booking_payment', 'booking_cancellation'];
